// removed by extract-text-webpack-plugin
module.exports = {"logoWrapper":"Logo__logoWrapper___1W_Ns"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/ControlPanel/Logo/Logo.css
// module id = 947
// module chunks = 0